import { NavLink } from "react-router-dom";
import { TourObj } from "../../../shared/types";
import Badge from "../../../shared/design/Badge";

type Props = {
  tourObj: TourObj;
};

/**
 * Design-system tour card: cover image with a color-coded difficulty pill,
 * mono location + rating row, serif title, and a price footer with an ink
 * circular arrow. Lifts on hover. Used on Home (featured), Tours, and Tour (related).
 */
const TourCard = ({ tourObj }: Props) => {
  const {
    id,
    name,
    difficulty,
    duration,
    price,
    ratingsAverage,
    imageCover,
    startLocation,
  } = tourObj;

  return (
    <NavLink
      to={`/tours/${id}`}
      className="group block overflow-hidden rounded-[20px] bg-white shadow-[0_14px_30px_-18px_rgba(0,0,0,0.25)] transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_30px_50px_-22px_rgba(0,0,0,0.4)]"
    >
      <div className="relative h-[230px] overflow-hidden">
        <img
          src={`${process.env.REACT_APP_API_URL}/img/tours/${imageCover}`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
          alt={name}
          crossOrigin="anonymous"
        />
        <Badge difficulty={difficulty} className="absolute left-3.5 top-3.5">
          {difficulty.toUpperCase()} · {duration} DAYS
        </Badge>
      </div>
      <div className="px-[22px] pb-6 pt-5">
        <div className="mb-1.5 flex items-center justify-between">
          <div className="font-mono text-[12px] text-muted-300">
            {startLocation?.description ?? ""}
          </div>
          <div className="text-[13px] font-bold">★ {ratingsAverage}</div>
        </div>
        <h3 className="mb-3.5 font-serif text-[23px] font-medium">{name}</h3>
        <div className="flex items-center justify-between border-t border-line-100 pt-[15px]">
          <div>
            <span className="text-[19px] font-extrabold">
              ${price.toLocaleString()}
            </span>
            <span className="text-[13px] text-muted-300"> /person</span>
          </div>
          <span className="flex h-[38px] w-[38px] items-center justify-center rounded-full bg-ink text-white">
            →
          </span>
        </div>
      </div>
    </NavLink>
  );
};

export default TourCard;
